// styles.js
export const datePickerStyles = (bgColor, focusColor) => {
  const textColor = bgColor ? "black" : "white"; // Set text color based on bgColor
  const hoverColor = focusColor ? "black" : "var(--primaryHeading) !important"
  
  return {
    minWidth: 200,
    width: '100%',
    '& .MuiInputBase-root': {
      backgroundColor: bgColor || 'var(--themeShadowColor) !important',
      fontSize: '14px',
      color: textColor, // Use dynamic text color
      borderRadius: '8px',
      border: "4px",
    },
    '& .MuiInputBase-input': {
      padding: {
        xs: '10px 8px',
        lg: '10px 0',
      },
      color: textColor, // Use dynamic text color here as well
      '::placeholder': {
        color: '#bbb', // Set placeholder color to light grey
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#8a8a8a', // Default border color
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: hoverColor, // Hover border color
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: focusColor || 'var(--primaryHeading) !important', // Focus border color
    },
  };
};

export const openPickerButtonStyles = {
  sx: {
    color: "#bbb",
  },
};

export const inputAdornmentStyles = {
  position: "start",
};

export const datePickerCalendarStyles = {
  "& .MuiPaper-root": {
    backgroundColor: "black !important", // Ensures dark background
    borderRadius: "8px",
    color: "white !important",
  },
  "& .MuiPickersCalendarHeader-root": {
    backgroundColor: "black !important",
  },
  "& .MuiPickersCalendarHeader-label": {
    color: "white !important",
    fontWeight: "bold",
  },
  "& .MuiPickersArrowSwitcher-root button": {
    color: "white !important", // Arrows for navigating months/years
  },
  "& .MuiSvgIcon-root": {
    color: "white !important", // All icons (arrows, close button)
  },
  "& .MuiPickersDay-root": {
    color: "white !important", // Ensure day text is visible
    borderRadius: "50% !important", // Circular day selection
    "&.Mui-selected": {
      backgroundColor: "var(--primaryHeading) !important", // Selected date
      color: "white !important",
    },
    "&:hover": {
      backgroundColor: "var(--primaryHeading) !important", // Hover effect
      color: "white !important",
    },
    "&.Mui-disabled": {
      color: "gray !important", // Disabled days gray
      opacity: 0.5,
    },
  },
  "& .MuiPickersYear-yearButton": {
    color: "white !important", // Year selection text
    "&.Mui-selected": {
      backgroundColor: "var(--primaryHeading) !important",
      color: "white !important",
    },
    "&.Mui-disabled": {
      color: "gray !important", // Disabled years gray
      opacity: 0.5,
    },
  },
  "& .MuiPickersMonth-root": {
    color: "white !important", // Month selection text
    "&.Mui-selected": {
      backgroundColor: "var(--primaryHeading) !important",
      color: "white !important",
    },
  },
  "& .MuiPickersToolbar-root": {
    backgroundColor: "black !important", // Toolbar background
    color: "white !important", // Toolbar text
  },
  "& .MuiTypography-root": {
    color: "white !important", // Ensures all text remains visible
  },
};